'use strict';

angular.module('myApp.pressEssayDetails', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/pressEssayDetails/:categoryId/:essayId/:location?', {
        templateUrl: 'app/pressEssayDetails/essayDetails.html',
        controller: 'PressEssayDetailsCtrl'
    });
}])

.controller('PressEssayDetailsCtrl', ['$scope', '$http', '$location', 'apiCall', '$routeParams', '$rootScope', 'baseApiUrl', '$q', '$timeout', 'growl', 'tokenService', '$anchorScroll', '$sce', 'MyService', 'ngDialog', function($scope, $http, $location, apiCall, $routeParams, $rootScope, baseApiUrl, $q, $timeout, growl, tokenService, $anchorScroll, $sce, MyService, ngDialog) {

    //MyService.ConsoleLog("* PressEssayDetailsCtrl *");
    $rootScope.welcome = false;
    $scope.categoryId = $routeParams.categoryId;
    $scope.essayId = $routeParams.essayId;
    $scope.userType = tokenService.getUserRole();
    $scope.uData = JSON.parse(tokenService.getUserData());
    $scope.froumthreads = [];
    $scope.essay = {};
    $scope.Sticky = {
        ShowOrder: [],
        txtOrder: []
    };
    $scope.vote = {
        recommend: 0,
        factual: 0
    };
    $scope.GalleryFolder = baseApiUrl + "/resources/" + $scope.uData.uname;

    $scope.displayComments = true;
    $scope.Reply = {};

    $scope.checkMemId = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata.userData._id == $rootScope.UserId)
                    return rdata
            }
        );
    }


    $scope.CheckUrl = function(url, option) {
        if (url) {
            if (url.indexOf("youtube.com") >= 0) {
                var url = url.replace("watch?v=", "embed/");
                if (option == "V")
                    return $sce.trustAsHtml('<br/><iframe width="560" height="315" src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
                else
                    return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
            }
            if (url.indexOf("facebook.com") >= 0) {
                if (option == "V")
                    return $sce.trustAsHtml('<br/><iframe src="' + url + '" width="560" height="315" frameborder="0"></iframe><br/>');
                else
                    return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
            }
            if (url.indexOf("vimeo.com") >= 0) {
                if (url.indexOf("https://vimeo.com/") >= 0) {
                    var id = url.replace("https://vimeo.com/", "");
                    var newurl = "https://player.vimeo.com/video/" + id;
                } else {
                    var newurl = url;
                }
                if (option == "V")
                    return $sce.trustAsHtml('<br/><iframe src="' + newurl + '" width="500" height="281" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>');
                else
                    return $sce.trustAsHtml('<br/><iframe src="' + newurl + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe><br/>');
            }
            if (option == "V")
                return $sce.trustAsHtml('<br/><iframe width="560" height="315" src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
            else
                return $sce.trustAsHtml('<br/><iframe src="' + url + '" frameborder="0" allowfullscreen></iframe><br/>');
        }

    }

    $scope.chkIfVoted = function(rdata, val) {
        return rdata.filter(
            function(rdata) {
                if (rdata.user.id == val)
                    return rdata

            }
        );
    }
    $scope.loginUser = tokenService.getUserId();
    $scope.getEssayDetails = function() {
        //MyService.ConsoleLog("Get One called");
        MyService.getPressEssay($routeParams.essayId).then(function(payload) {
            $scope.essay = payload;
            //MyService.ConsoleLog("payload:",payload);
            var chkrecommend = $scope.chkIfVoted(payload.recommended, $scope.loginUser);
            //MyService.ConsoleLog("chkrecommend : ", chkrecommend);
            if ((chkrecommend) && (chkrecommend.length > 0)) {
                $scope.vote.recommend = chkrecommend[0].vote;
            }
            var chkfactual = $scope.chkIfVoted(payload.factual, $scope.loginUser);
            if (chkfactual && chkfactual.length > 0) {
                $scope.vote.factual = chkfactual[0].vote;
            }

        }, function(errorPayload) {
            //MyService.ConsoleLog(errorPayload);
            alert('Something went wrong ');
        });

    }



    function getCategory() {
        MyService.getCategoryList($routeParams.categoryId).then(function(payload) {
            $scope.category = payload;

        }, function(errorPayload) {
            alert('Something went wrong ');
        });

    }

    $scope.gotoThread = function(data) {
        //MyService.ConsoleLog(data);
        var id = '';
        if (data.parentId) {
            id = data.parentId;
        } else {
            id = data.id;
        }
        $location('forumthread/' + id);
    }

    $scope.updateCommentApi = function(data, options, idex) {

        MyService.updatePressEssayComments(data).then(function(payload) {
            if (payload.nModified == 0) {
                alert("You already provided your inputs on this post");
            } else {
                switch (options) {
                    case 'like':
                        $scope.essayComments[idex].totalLikes = $scope.essayComments[idex].totalLikes + 1;
                        break;
                    case 'dislike':
                        $scope.essayComments[idex].totalDislike = $scope.essayComments[idex].totalDislike + 1;
                        break;
                    default:
                        $scope.essayComments[idex].totalSpam = $scope.essayComments[idex].totalSpam + 1;
                        break;
                }
            }
        }, function(response) {
            if (response.error) {
                alert(response.error);
                //MyService.ConsoleLog(response);
                if ((response.status) && (response.status == "405")) {
                    var msg = "Do you want to send request to Admin to reactivate your account?.";
                    MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                        MyService.sendActivatationMailtoAdmin().then(function(payload) {
                            alert("Request sent successfully to admin");
                        }, function(errorPayload) {
                            alert("Something went wrong");
                        })
                    }, function(errorPayload) {
                        //MyService.ConsoleLog(errorPayload);
                    });
                }
            }

        });

    }



    $scope.updateComments = function(options, id, idex) {

        if ($rootScope.UserId) {
            if ($scope.essayComments[idex].createdBy.id != $rootScope.UserId) {
                var commentData = {};
                commentData.commentId = id;
                commentData.userId = $rootScope.UserId;

                switch (options) {
                    case 'like':
                        commentData.likes = 1;
                        break;
                    case 'dislike':
                        commentData.dislikes = 1;
                        break;
                    default:
                        commentData.spam = 1;
                        break;

                }
                $scope.updateCommentApi(commentData, options, idex);
            } else {
                alert("You cannot " + options + " your own comments");
            }

        } else {
            alert("Please login to perform these actions");
        }
    }
    $scope.submitSticky = function(data, id, idx) {
        if (data > 0) {
            updateForum('sticky', id, idx);
        } else {
            alert("Please enter valid order");
        }

    }
    $scope.ShowComments = false;
    $scope.redirectToComment = function() {
        if (!$rootScope.UserId) {
            $location.path('signin');
        }
        $scope.ShowComments = true;
        $scope.displayComments = false;
        //$location.path('forumReply/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);

    }



    $scope.goBack = function() {
        $scope.ShowComments = false;
        $scope.displayComments = true;
    }
    $scope.getComments = function() {

        MyService.getPressEssayComments($routeParams.essayId).then(function(payload) {
                $scope.essayComments = payload;
            },
            function(errorPayload) {
                alert('Something went wrong ');
            });


    }

    $scope.SubmitComment = function(rec) {
        //MyService.ConsoleLog(data);
        //MyService.ConsoleLog($scope.mainThread);
        var data = {};
        if (rec.content != "") {
            $scope.TopicButton = true;
            data.createdById = $rootScope.UserId;
            data.createdByName = $rootScope.User;
            data.createdByType = tokenService.getUserRole();
            data.comments = rec.content;
            data.essayId = $routeParams.essayId;
            //MyService.ConsoleLog(data);


            /*MyService.submitPressEssayComments(data).then(function(payload) {
                $scope.comments = {
                    content: ''
                };
                $scope.ShowComments = false;
                $scope.displayComments = true;
                $scope.mainThread = {};
                //$location.path('forumthread/'+$routeParams.categoryId+'/'+$routeParams.subcatId+'/'+$routeParams.essayId);
                $scope.getComments();
            }, function(response) {
                if (response.error) {
                    alert(response.error);
                    //MyService.ConsoleLog(response);
                    if ((response.status) && (response.status == "405")) {
                        var msg = "Do you want to send request to Admin to reactivate your account?.";
                        MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                            MyService.sendActivatationMailtoAdmin().then(function(payload) {
                                alert("Request sent successfully to admin");
                            }, function(errorPayload) {
                                alert("Something went wrong");
                            })
                        }, function(errorPayload) {
                            //MyService.ConsoleLog(errorPayload);
                        });
                    }
                }
            });*/
        } else {
            alert("Please enter comments.");
        }
    }

    $scope.EssayVote = function(option) {
        if ($scope.essay.createdBy.id != tokenService.getUserId()) {
            var data = {};
            data.essayId = $routeParams.essayId;
            data.mediaType = '';
            data.option = option;
            //MyService.ConsoleLog(option);
            if (option == "Recommended") {
                data.vote = $scope.vote.recommend;
            } else {
                data.vote = $scope.vote.factual;
            }
            data.createdById = $scope.loginUser;
            data.createdByName = tokenService.getUserName();
            data.createdByType = tokenService.getUserRole();
            MyService.updatePressEssay(data).then(function(payload) {
                    alert('Thank you for rating the essay.');
                },
                function(response) {
                    if (response.error) {
                        alert(response.error);
                        //MyService.ConsoleLog(response);
                        if ((response.status) && (response.status == "405")) {
                            var msg = "Do you want to send request to Admin to reactivate your account?.";
                            MyService.GetDialogWithButtons(ngDialog, msg, "YES", "NO").then(function(payload) {
                                MyService.sendActivatationMailtoAdmin().then(function(payload) {
                                    alert("Request sent successfully to admin");
                                }, function(errorPayload) {
                                    alert("Something went wrong");
                                })
                            }, function(errorPayload) {
                                //MyService.ConsoleLog(errorPayload);
                            });
                        }
                    }
                });
        } else {
            alert("You cannot vote your own essay.");
        }

    }



    if ($routeParams.categoryId) {
        //getCategory();
        $scope.getEssayDetails();
        $scope.getComments();
    }
}]);
